import { runStopAnimation } from './stop-playback-implementation';

export async function runStopAnimationImplementation(data: {
  target?: { id?: string };
  clip?: string;
  transitionDuration?: number;
}) {
  const targetId = data?.target?.id;
  if (!targetId) return;
  runStopAnimation({
    allTargets: false,
    targetId,
    clip: data?.clip,
    transitionDuration: data?.transitionDuration ?? 0,
  });
}

export async function runStopAllAnimationsOfObjectImplementation(data: {
  target?: { id?: string };
}) {
  const targetId = data?.target?.id;
  if (!targetId) return;
  runStopAnimation({ allTargets: false, targetId });
}

export async function runStopAllAnimationsImplementation() {
  runStopAnimation({ allTargets: true });
}
